import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Message, Table } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import settings from "../../settings";
import { ERR_TEXTBOX_NOT_FILLED } from "../../ErrorMessages";

class PickUserForm extends React.Component {
  state = {
    data: {
      pickuser: "",
      appname: settings.appName,
    },
    loading: false,
    errors: {},
  };

  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props.submit(this.state.data);
      this.setState({ loading: false });
    }
  };

  validate = (data) => {
    const errors = {};
    if (!data.pickuser) {
      errors.pickuser = ERR_TEXTBOX_NOT_FILLED;
      const element = document.getElementById("pickuser");
      if (element) element.focus();
    }
    return errors;
  };

  render() {
    const { data, errors, loading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {errors.global && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global}</p>
          </Message>
        )}
        <Table className="table-no-border">
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <label className="font-family" htmlFor="pickuser">
                  Pick User:
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Field error={!!errors.pickuser}>
                  <input
                    type="text"
                    id="pickuser"
                    name="pickuser"
                    tabIndex="a"
                    autoComplete="pickuser"
                    placeholder="Enter your user ID"
                    value={data.pickuser}
                    onChange={this.onChange}
                  />
                  {errors.pickuser && (
                    <Table.Row>
                      <Table.Cell colSpan={3}>
                        <InlineError text={errors.pickuser} />
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Button primary>Submit</Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Form>
    );
  }
}

PickUserForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default PickUserForm;



// WEBPACK FOOTER //
// ./src/components/forms/PickUserForm.js